(function ($, Drupal) {
  'use strict';

  $(document).ready(init);

  function init() {

    var question = $('.node-faq-full__title');

    question.click(toggleQuestion);

    question.each(function () {
      var answer = $(this).closest('.node-faq-full').find('.node-faq-full__content');
      answer.slideUp('fast');
    });

  }

  function toggleQuestion(e) {
    var item = $(e.currentTarget);
    var parent = item.closest('.node-faq-full');
    var answer = parent.find('.node-faq-full__content');

    if (parent.hasClass('node-faq-full--open')) {
      parent.removeClass('node-faq-full--open');
      answer.slideUp('fast');
    }
    else {
      $('.node-faq-full--open').removeClass('node-faq-full--open').find('.node-faq-full__content').slideUp('fast');
      parent.addClass('node-faq-full--open');
      answer.slideDown('fast');
    }


  }

})(jQuery, Drupal);
